// import vue from 'vue'
import axios from 'axios'

// 允许跨域携带cookie信息
axios.defaults.withCredentials = true

// 添加请求拦截
axios.interceptors.request.use(
  config => {
    // config.headers['Accept'] = 'application/json'
    // config.headers['Content-Type'] = 'application/json'
    // config.headers['Authorization'] = ''
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 添加响应拦截
axios.interceptors.response.use(
  response => {
    // switch (response.data.status_code) {
    //   case 0:
    //     // 请求成功
    //     break
    //   case 10:
    //     // 未登录
    //     break
    //   case 11:
    //     // token 失效
    //     break
    //   case 12:
    //     break
    //   default:
    // }
    return response.data
  },
  error => {
    return Promise.reject(error)
  }
)

export default axios



// WEBPACK FOOTER //
// ./src/utils/http.js